module.exports = __webpack_public_path__ + "img/9.45847351.jpeg";